exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".album-container[data-v-aa3dfbec]{padding:10px 0;margin-bottom:20px}.album-inner-container[data-v-aa3dfbec],.photo-container[data-v-aa3dfbec]{display:-ms-flexbox;display:-webkit-box;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.photo-container[data-v-aa3dfbec]{margin:15px 10px;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}img[data-v-aa3dfbec]{max-width:100%;margin:10px 0;-o-object-fit:contain;object-fit:contain;cursor:pointer}@media (min-width:600px){img[data-v-aa3dfbec]{margin:10px;width:42%}}@media (min-width:1200px){img[data-v-aa3dfbec]{margin:10px 20px;width:auto;height:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa3dfbec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PhotoAlbum.vue
// module id = 256
// module chunks = 0